
import React = require('react');
import ReactDOM = require('react-dom');
import { SharedCompUserList, IUserItem } from './SharedCompUserList';
import Ajax from '../../lib/Ajax';
import { Tools } from '../../lib/Tools';
import { IProfileCompData } from '../../../interfaces/layout/blocks/IUser';

interface NearbyFamilyMemberProps {
    userId:number
}

interface NearbyFamilyMemberState {
    items:Array<IUserItem>
}

class NearbyFamilyMember extends React.Component<NearbyFamilyMemberProps, NearbyFamilyMemberState>{

      constructor(props:NearbyFamilyMemberProps){
        super(props);
        // set initial state
        this.state = this.getInitState();
        // tslint:disable-next-line:no-unused-expression
        new Ajax('/user/getNearbyFamilyMembers', 'POST', {
            id: this.props.userId
        }, (data:IProfileCompData) => {
            var items:Array<IUserItem> = [];
            for (var key in data.live) {
                var item = data.live[key];
                items.push({
                    id: item.id,
                    name: item.name,
                    img: item.img,
                    link: '/profilok/' + item.id,
                    affinity: item.affinity,
                    address: undefined
                });
            }

            this.setState({
                items : items
            });
        });
    }


    protected getInitState():any{
        return {
            items: []
        };
    }

    render() {
        if ( this.state.items.length === 0 ) {
            return(<div></div>);
        }
        return (
            <SharedCompUserList editMode={false} title="Közvetlen család" emptyText="" userList={ this.state.items } />
        );
    }
}
export class InitNearbyFamilyMember {
    constructor() {
        var div: HTMLDivElement = document.getElementById('neraby_family_member') as HTMLDivElement;
        if (div !== null) {
           ReactDOM.render(<NearbyFamilyMember userId={ parseInt(div.dataset.id) } />, div);
        }
    }
}





// WEBPACK FOOTER //
// ./components/event/NearbyFamilyMember.tsx